<template>
  <b-modal
    id="all-bookings-modal"
    ref="all-bookings-modal-ref"
    hide-footer
    title="All Bookings"
    @hidden="onModalHidden">
    <div class="all-bookings">
      <div v-if="bookings">
        <div v-for="(group, status, index) in groupedBookings" :key="status">
          <b-button
            v-if="group[0] !== ''"
            v-b-toggle="'accordion-' + index"
            class="check-in-main"
            :class="dropDown"
            :id="'buttonID-' + index"
            size="sm"
            @click="toggleExpand(index)">
            <div class="item-title">
              <span>{{ status }}</span>
            </div>
            <div class="toggle-essential">
              <span v-if="!dropDown[index]">+</span>
              <span v-else>-</span>
            </div>
          </b-button>

          <b-collapse :id="'accordion-' + index" accordion="my-accordion" role="tabpanel">
            <b-alert
              show
              variant="danger"
              class="alert alert-card-combo p-2 alert-primary"
              v-if="
                status === 'ARCHIVED BOOKINGS' ||
                status === 'CANCELLED BOOKINGS' ||
                (status === 'ARCHIVED BOOKINGS' && status === 'CANCELLED BOOKINGS')
              ">
              <p class="card-text alert-container warning-msg">
                <i class="material-icons icon mr-2 mb-2">priority_high</i
                ><b>Unavailable for Viewing</b>
              </p>
            </b-alert>
            <div v-for="(booking, i) in group" :key="i">
              <a
                class="all-booking-a-tag"
                :class="{
                  'disabled all-booking-cursor':
                    status === 'ARCHIVED BOOKINGS' ||
                    status === 'CANCELLED BOOKINGS' ||
                    (status === 'ARCHIVED BOOKINGS' && status === 'CANCELLED BOOKINGS'),
                }"
                @click.prevent="
                  onClickBooking(booking.histbookno, booking.histstatus, booking.histname)
                ">
                <b-card-body v-if="booking">
                  <div class="item-dropdown accordions">
                    <div class="item-dropdown-main accordions-main">
                      <div class="all-booking-content border-content item-width1">
                        <h6>Departure Date:</h6>
                        <p>
                          <b>{{ booking.histdepdate }}</b>
                        </p>
                      </div>
                      <div class="all-booking-content border-content item-width1 reference-width">
                        <h6>Reference:</h6>
                        <p>
                          <b>{{ booking.histbookno }}</b>
                        </p>
                      </div>
                      <div class="all-booking-content border-content item-width1">
                        <h6>Name:</h6>
                        <p>
                          <b>{{ booking.histname }}</b>
                        </p>
                      </div>
                      <div class="all-booking-content border-content item-width2">
                        <h6>Destination:</h6>
                        <p>
                          <b>{{ booking.histdest }}</b>
                        </p>
                      </div>
                    </div>
                  </div>
                </b-card-body>
              </a>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  data() {
    return {
      dropDown: [],
    }
  },
  computed: {
    ...mapState('allBookings', ['bookings']),
    groupedBookings() {
      const bookings = this.bookings.sorted_history[0]
      const grouped = {}
      for (const index in bookings) {
        const booking = bookings[index]
        const status = booking.bkgstatus

        for (const i in booking.histbkg) {
          const histbooking = booking.histbkg[i]

          if (!grouped[status]) {
            grouped[status] = []
          }
          grouped[status].push(histbooking)
        }
      }
      return grouped
    },
  },
  methods: {
    toggleExpand(index) {
      // loop through dropDown array and set all values to false except for the clicked index
      this.dropDown = this.dropDown.map((value, i) => (i !== index ? false : value))

      // toggle the clicked button
      this.dropDown[index] = !this.dropDown[index]
    },
    onModalHidden() {
      this.dropDown = [false]
    },
    show() {
      this.$refs['all-bookings-modal-ref'].show()
      this.loadAllBookings()
    },
    async onClickBooking(number, status, name) {
      if (status === 'L') {
        const res = await this.switchBooking({ number: number, name: name })
        if (res) {
          this.$router.push('/booking')
        }
      }
    },
    ...mapActions({
      loadAllBookings: 'allBookings/loadAllBookingsAction',
      switchBooking: 'allBookings/switchBookingAction',
    }),
  },
}
</script>

<style>
@import './styles.scss';
</style>
